<template>
  <el-dialog title="添加角色" :visible="visible" width="400px" :close-on-click-modal="false"
    @close="$emit('update:visible', false)">
    <el-form :model="form" :rules="rules" ref="formRef" label-width="100px" label-position="left">
      <el-form-item label="角色名称" prop="roleName">
        <el-input v-model="form.roleName" placeholder="请输入角色名称" />
      </el-form-item>
      <el-form-item label="角色标识" prop="roleKey">
        <el-input v-model="form.roleKey" placeholder="请输入角色标识" />
      </el-form-item>
      <el-form-item label="角色顺序" prop="sort">
        <el-input-number v-model="form.sort" :min="0" />
      </el-form-item>
      <el-form-item label="状态">
        <el-radio-group v-model="form.status">
          <el-radio label="1">启用</el-radio>
          <el-radio label="0">禁用</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="$emit('update:visible', false)">取消</el-button>
      <el-button type="primary" @click="handleSubmit">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { roleAdd } from '@/api/api'

export default {
  name: 'AddRoleDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        roleName: '',
        roleKey: '',
        sort: 0,
        status: '1'
      },
      rules: {
        roleName: [{ required: true, message: '请输入角色名称', trigger: 'blur' }],
        roleKey: [{ required: true, message: '请输入角色标识', trigger: 'blur' }],
        sort: [{ required: true, message: '请输入角色顺序', trigger: 'blur' }]
      },
      loading: false
    }
  },
  methods: {
    handleSubmit() {
      this.$refs.formRef.validate(valid => {
        if (valid) {
          this.loading = true
          // 准备调用接口的参数，映射字段
          const params = {
            title: this.form.roleName,
            slug: this.form.roleKey,
            sort: this.form.sort.toString(),
            status: this.form.status
          }
          console.log('调用roleAdd接口，参数:', params)
          // 调用roleAdd接口
          roleAdd(params)
            .then(response => {
              console.log('roleAdd接口响应:', response)
              if (response && response.code === 200) {
                this.$message.success('角色添加成功')
                this.$emit('submit', this.form)
                this.$emit('update:visible', false)
              } else {
                this.$message.error('角色添加失败：' + (response.message || '未知错误'))
              }
            })
            .catch(error => {
              console.error('角色添加失败:', error)
              this.$message.error('角色添加异常，请重试')
            })
            .finally(() => {
              this.loading = false
            })
        }
      })
    }
  }
}
</script>

<style scoped></style>